import React, { useEffect, useState } from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import i18next from "i18next";
import PrepareDataTable from "./PrepareDataTable";
import AddEditMailToken from "../AddEditMailToken/AddEditMailToken";
import { MailTokenListContainer, Title } from "./MailTokenList.styled";

import "./MailTokenList.scss";

/**
 * MailToken List (Email Templates Management),
 * Path - /mailTokens
 * @component
 */
const MailTokenList = (props) => {
  const { t, columnList } = props;

  const [isRefreshList, setIsRefreshList] = useState(false);
  const [isAddMailTokenPopupVisible, setAddMailTokenPopupVisible] =
    useState(false);
  const [selectedMailToken, setSelectedMailToken] = useState(null);
  const [isEditMode, setIsEditMode] = useState(false);

  const updateRefeshStatus = () => {
    setIsRefreshList(true);
  };

  const createNewMailToken = () => {
    setSelectedMailToken(null);
    setIsEditMode(false);
    setAddMailTokenPopupVisible(true);
  };

  const editMailToken = (mailToken) => {
    setSelectedMailToken(mailToken);
    setIsEditMode(true);
    setAddMailTokenPopupVisible(true);
  };

  const closeMailTokenPopup = () => {
    setAddMailTokenPopupVisible(false);
    setSelectedMailToken(null);
    setIsEditMode(false);
  };

  useEffect(() => {
    if (isRefreshList) {
      setIsRefreshList(false);
    }
  }, [isRefreshList]);

  return (
    <MailTokenListContainer className="mailtoken-list">
      <h2 className="kick-off-list__title">
        {t("ADMINISTRATION_EMAILS_TEMPLATES")}
      </h2>
      <PrepareDataTable
        isRefreshList={isRefreshList}
        columnList={columnList}
        updateRefeshStatus={updateRefeshStatus}
        createNewMailToken={createNewMailToken}
        editMailToken={editMailToken}
      />
      {isAddMailTokenPopupVisible && (
        <AddEditMailToken
          title={t("EMAIL_TOKEN")}
          id={selectedMailToken?.id}
          isEditMode={isEditMode}
          selectedMailToken={selectedMailToken}
          onClose={closeMailTokenPopup}
          updateRefeshStatus={updateRefeshStatus}
        />
      )}
    </MailTokenListContainer>
  );
};

MailTokenList.propTypes = {
  t: PropTypes.func.isRequired,
  columnList: PropTypes.arrayOf(PropTypes.string),
};

MailTokenList.defaultProps = {
  columnList: [],
};

export default withTranslation()(MailTokenList);
